/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// --- Google Maps Places Autocomplete (kept) ---
document.addEventListener('DOMContentLoaded', function () {
  var input = document.getElementById('address');
  if (input && window.google && google.maps && google.maps.places) {
    /* global google */
    try {
      var autocomplete = new google.maps.places.Autocomplete(input);
    } catch (e) {
      // Silently ignore if Google script is not available
      console.warn('Google Places Autocomplete init skipped:', e);
    }
  }
});

// --- Tooltip toggle (kept) ---
// Uses jQuery if available; otherwise does nothing.
(function () {
  if (window.jQuery) {
    jQuery(function ($) {
      $('#custom_tooltip').on('click', function () {
        var $tip = $('.custom_tooltiptext');
        if ($tip.length) {
          $tip.css('visibility', $tip.css('visibility') === 'hidden' ? 'visible' : 'hidden');
        }
      });
    });
  }
})();